<div class="modal" [ngClass]="{'active': isActiveThis}">
    <div class="modal-overlay" (click)="closeModal()" aria-label="Close modal"></div>
    <div #modalContainer 
         class="modal-container" 
         [ngClass]="getModalSizeClass()"
         (click)="onModalContentClick($event)"
         role="dialog" 
         aria-modal="true"
         [attr.aria-labelledby]="titleThis ? titleId : null">

        <div class="modal-header">
            <h5 [id]="titleId" class="modal-title h5">
                {{titleThis | translate}}
            </h5>
            <button *ngIf="showCloseButton"
                    class="btn btn-clear" 
                    (click)="closeModal()"
                    aria-label="Close modal"
                    type="button">
            </button>
        </div>
        
        <div class="modal-body">
            <!-- Confirm/delete layout (Business-Unit design): icon + message. -->
            <ng-container *ngIf="confirmCallback && bodyThis; else plainBody">
                <div class="confirm-head">
                    <span class="confirm-ico" [class.danger]="confirmDanger">
                        <i class="fas" [ngClass]="confirmDanger ? 'fa-trash' : 'fa-circle-question'" aria-hidden="true"></i>
                    </span>
                    <p class="confirm-msg" [innerHTML]="bodyThis"></p>
                </div>
            </ng-container>
            <ng-template #plainBody>
                <div class="content" *ngIf="bodyThis" [innerHTML]="bodyThis"></div>
                <div class="content" *ngIf="!bodyThis">
                    <ng-content></ng-content>
                </div>
            </ng-template>
        </div>

        <div class="modal-footer" *ngIf="confirmCallback">
            <button class="btn btn-link"
                    (click)="closeModal()"
                    type="button">
                {{ cancelLabel | translate }}
            </button>
            <button class="btn btn-primary"
                    (click)="confirmClick()"
                    type="button">
                <i *ngIf="confirmDanger" class="fas fa-trash" aria-hidden="true"></i>
                {{ confirmLabel | translate }}
            </button>
        </div>
    </div>
</div>